export const JUDICIAL_LABOR_COMPLEMENTO = (judicialLabor) => `Garantia Judicial Trabalhista destinada ao Processo nº ${judicialLabor.processNumber ?? '[nº do processo]'}. Trata-se de ${judicialLabor.proposedLegalAction ?? '[ação proposta]'} movida por ${judicialLabor.claimantName.replace('.', '') ?? '[nome]'}, CPF/CNPJ ${judicialLabor.claimantCnpj ?? '[CPF/CNPJ]'}, perante o tribunal ${judicialLabor.courtRegionalLabor ?? '[tribunal]'} e vara ${judicialLabor.courtSection ?? '[vara]'}.`

const JudicialGuaranteeLaborQuotation = {
  JUDICIAL_LABOR_COMPLEMENTO,
}

export default JudicialGuaranteeLaborQuotation
